export default "__VITE_ASSET__QQVxZU0w__"